import Vue from "vue";
import Router from "vue-router";
// import { constantRouterMap }  from "./router";
import { constantRouterMap } from "./routers";
import config from "@/utils/config";
Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
const router = new Router({
  // mode: "history",
  // routes
  routes: constantRouterMap
});

let WHITE_LIST = ["/login", ""];
router.beforeEach((to, from, next) => {
  const { $store, $axios } = router.app;
  window.scrollTo(0, 0);
  var configlink = ["/login", "/info", "/register", "/agreement", "/forget"];
  if (
    !(to.matched.length > 0) ||
    to.matched.some(record => record.meta && record.meta.auth === false)
  ) {
    if (localStorage.getItem("mp_accessToken")) {
      $store.commit("user/setnickname", localStorage.getItem("mp_nickname"));
      if (localStorage.getItem("groupType") !== "null") {
        next({ path: "/" });
      }
      next();
    } else {
      next();
    }
    return;
  }

  if (config.noLogin().includes(to.path)) {
    next();
  } else {
    if ("/index" == to.path) {
      $store.commit("user/setnickname", localStorage.getItem("mp_nickname"));
      next();
    } else {
      if (localStorage.getItem("mp_accessToken")) {
        $store.commit("user/setnickname", localStorage.getItem("mp_nickname"));
        console.log(
          'localStorage.getItem("groupType")',
          localStorage.getItem("groupType")
        );

        if (localStorage.getItem("groupType") !== "null") {
          console.log(1111);
          if (configlink.includes(to.path)) {
            next({ path: "/game_management" });
          } else {
            next();
          }
        } else {
          next({
            path: "/info"
          });
        }
      } else {
        next({
          path: "/login"
        });
      }
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js